import { Component, TemplateRef } from '@angular/core';
import { VlHttpService, VlDataService, HTTPAPIConfig, APIConfigMapping} from 'shared-library';

import { ActivatedRoute, Params } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
// import { Component } from '@angular/core';

export interface Entity {
  application_id: string;
  child_entity_ids_list: string[];
  entity_id: string;
  entity_name: string;
  open?: boolean;
}

export interface EntityDetails {
  widgetId: string;
  widgetLabel: string;
}

export interface PageDetails {
  pageId: string;
  pageName: string;
  pageType: string;
}

@Component({
  selector: 'lib-web-entity',
  templateUrl: './web-entity.component.html',
  styleUrls: ['./web-entity.component.scss']
})
export class WebEntityComponent {

  queryParams: {
    [key: string]: string;
  } = {};
 
  pageList: PageDetails[] = [];
  pageListDropdown: PageDetails[] = [];
  entityList: Entity[] = [];
  relatedEntityList: Entity[] = [];
  entityDetails: any;
  isAddEntity: boolean = false;
  isAddAttributes: boolean = true;
  isAddRelations: boolean = true;
  entityForm: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    attributes: new FormControl(null),
    child: new FormControl(null),
    childField: new FormGroup({
      parent: new FormControl(null),
      child: new FormControl(null)
    })
  })
  pagesAdded: PageDetails[] = [];
  entityPages: PageDetails[] = [];
  removedPages: string[] = [];
  relativeEntityAdded: Entity[] = [];
  relativeEntity: Entity[] = [];
  removedRelativeEntity: string[] = [];
  showRelativeField: boolean = false;
  entityFields: EntityDetails[] = [];
  selectedEntityFields: EntityDetails[] = [];
  relativeEntityForPostData: any = {};
  isEntityNameEdit: {
    [key: string]: boolean
  } = {};
  isEdit: boolean = false;
  popupEntity!: { entityId: string | null; entityName: string | null; };
  newEntityId!: string;
  isEntityNameUnique: boolean=true;
  childFieldClicked :boolean=false;
  parentFieldClicked:boolean=false;
  showselectEntityParentError:boolean = false;
  showselectEntityChildError:boolean = false;

  showselectPageError:boolean = false;
  selectedEntityName: string ='';
  matPanelStatus : boolean = false;
  relatedPanelStatus : boolean = false;
  buttonClickedChild: boolean = false;
  buttonClickedParent: boolean =false;

  
  constructor(
    private toastrService: ToastrService,
    private httpService: VlHttpService,
    private dataService: VlDataService,
    private route: ActivatedRoute,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.subscribeRouterEvents();
    this.subscribeFormEvents();
  }

  /**
   * calling the below method to subscribe the events for device profile update status
   */

  subscribeRouterEvents(){
    this.route.queryParams.subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          this.queryParams[param] = params[param];
        }
      }
      this.initMethods();
    });
  }

  subscribeFormEvents() {
    this.entityForm.get('attributes')?.valueChanges.subscribe((value: any) => {
      if(value) {
        const page = this.pageList.find((ele: PageDetails) => ele.pageId == value);
        if(page) {
          this.entityPages.push(page);
          this.pageListDropdown = this.pageList?.filter(page => !this.entityPages?.some(entityPage => entityPage?.pageId === page?.pageId));
        }
        // this.entityForm.get('attributes')?.reset();
        this.isAddAttributes = false;
        this.showselectPageError = false;
      }
    })
    this.relatedEntityList = this.entityList?.filter(entity => !this.relativeEntity?.some(entityPage => entityPage?.entity_id === entity?.entity_id));
    this.relatedEntityList.sort((a, b) => a.entity_name.localeCompare(b.entity_name));
    this.entityForm.get('')
  }

  isEntityUnique(newLabel: string): boolean {
    return !this.entityList.some(item => item.entity_name.toLowerCase().trim() === newLabel.toLowerCase().trim());
  }
  onEnterPressed(entityId :any){
    if(!this.entityForm.invalid && this.isEntityNameUnique === true){
      this.saveEntiy(entityId);
    }

  }

  onEntityNameAdd(event :any){
    
    if(!this.isEntityUnique(event.target.value)){
      this.isEntityNameUnique = false;
    } else{
      this.isEntityNameUnique = true;
    }
    
    const addEntityName: any = this.entityForm.value.name.trimLeft();
    this.entityForm.get('name')?.setValue(addEntityName);
  }

  editEntityName(template:TemplateRef<any>, entityId: string, entityName: string) {
    this.isEntityNameEdit[entityId] = true;
    this.entityForm.get('name')?.setValue(entityName);
    this.openModal(template, true, entityId, entityName);
    this.entityForm.patchValue({
      name:entityName
    })
  }

  openModal(template:TemplateRef<any>, isEdit: boolean, entityId: string | null = null, entityName: string | null = null): void {
    this.entityForm.reset();
    const dialogRef = this.dialog.open(template, {
      disableClose: true,
      restoreFocus:false
    });
    this.isEdit = isEdit;
    this.popupEntity = {
      entityId,
      entityName
    }
    console.log(this.popupEntity, 'entity popup edit');
    
  }

  closeTemplate(): void {
    this.dialog.closeAll();
  }

  saveEntiy(entityId: string | null = null) {
    this.selectedEntityName = this.entityForm.get('name')?.value;
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['UPDATE_ENTITY']);
    apiConfig.postData = {
      entity_id: entityId,
      entity_name: this.entityForm.get('name')?.value,
      child_entity_ids_relation: null,
      application_id: this.queryParams['id'],
      page_ids_list: null,
      removal_page_ids_list: null,
      removal_child_entity_ids_relation: null
    }

    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (response: any) => {
        this.newEntityId = response.entity_id;
        this.toastrService.success(response.message);        
      },
      complete: async () => {
        this.closeTemplate();
        this.entityPages = [];
        this.entityList = await this.fetchEntity();
        this.entityDetails = await this.fetchEntity(this.newEntityId);
        this.entityList.map((value: Entity, index: number) => { value.open = value.entity_id == this.newEntityId ? true: false;})
      },
      error: () => {}
    })
  }

  addPage() {
    this.isAddAttributes = true;
    this.entityForm.get('attributes')?.value ? this.showselectPageError = false : this.showselectPageError = true; 
    this.entityForm.get('attributes')?.reset();
    
  }
  
  removePageFromEntity(pageId: string, index: number) {
    this.removedPages.push(pageId);
    const entityPages = this.entityPages.splice(index, 1)[0];
    this.pageListDropdown.push(entityPages);  
    this.pageListDropdown.sort((a, b) => a.pageName.localeCompare(b.pageName));
  }

  togglePanelRelatedEntity(entity : boolean){
   (!entity)? this.showRelativeField=entity:'';
    this.parentFieldClicked=false;
    this.childFieldClicked=false;
    this.showselectEntityParentError=false;
    this.showselectEntityChildError=false;
    this.relatedPanelStatus = entity;
  }

  addRelatedEntities() {
    this.isAddRelations = true;
    const relativeEntity = this.entityForm.get('child')?.value;
    const childFieldsData = this.entityForm.get('childField')?.value;
    this.buttonClickedChild = true; 
    this.buttonClickedParent =true;
    this.showselectEntityParentError = childFieldsData.parent ? false : true;
    this.showselectEntityChildError = childFieldsData.child ? false : true;
    if(!Object.values(childFieldsData).every(value => value !== null && value !== undefined)) {
      return;
    }
    
    if(relativeEntity) {
      const entity = this.entityList.find((ele: Entity) => ele.entity_id == relativeEntity);
      if(entity) {
        this.relativeEntity.push(entity);
        this.relativeEntityForPostData[relativeEntity] = this.entityForm.get('childField')?.value;
      }
      this.entityForm.get('child')?.reset();
      this.entityForm.get('childField')?.reset();
      this.showRelativeField = false;
      this.relatedEntityList = this.entityList?.filter(entity => !this.relativeEntity?.some(entityPage => entityPage?.entity_id === entity?.entity_id));
      this.relatedEntityList.sort((a, b) => a.entity_name.localeCompare(b.entity_name));      
    }
  }

  async initMethods() {
    this.entityPages = [];
    this.entityList = await this.fetchEntity();
    await this.fetchPages();

    this.entityForm.get('child')?.valueChanges.subscribe(async (value: any) => {
      if(value) {
        this.selectedEntityFields = [];
        const relativeEntityDetails = await this.fetchEntity(value, false);
        this.entityFields = this.fetchEntityFields(this.entityDetails.page_widget_details);        
        this.selectedEntityFields = this.fetchEntityFields(relativeEntityDetails.page_widget_details);
        this.showRelativeField = true;
        this.relatedEntityList = this.entityList?.filter(entity => !this.relativeEntity?.some(entityPage => entityPage?.entity_id === entity?.entity_id));
        this.relatedEntityList.sort((a, b) => a.entity_name.localeCompare(b.entity_name));
      }
    })
  }
 
  handleParentFieldTouch() {
    this.parentFieldClicked = true;
    this.buttonClickedParent = false;
  }

  handleChildFieldTouch(){
    this.childFieldClicked = true; 
    this.buttonClickedChild = false;
  }

  fetchEntityFields(entity: any) {
    let returnValue: any[] = [];
    for(let page of entity) {
      returnValue = returnValue.concat(page.widget_details);
    }

    return returnValue;
  }

  async fetchEntity(entity_id: string | null = null, isEntityPageUpdate: boolean = true) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_ENTITIES_OR_ATTRIBUTES']);

    apiConfig.postData = {
      application_id: this.queryParams['id'],
      entity_id: entity_id,
      project_id: null,
      parent_entity_id: null
    }
    const dataStore = entity_id? 'entityDetails' : 'entityList';
    const returnData: any = await new Promise((resolve: any, reject) => {
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (response: any) => {
          if(isEntityPageUpdate) {
            if(!entity_id) {
              if(response.data.length > 0) {
                response.data.map((value: Entity, index: number) => { value.open = index == 0 ? false: false; this.isEntityNameEdit[value.entity_id] = false; })
              }
            }else {
              this.relativeEntity = [];
              this.entityPages = [];
              this.relativeEntityForPostData = {};
              for(let page of response.data.page_ids) {
                const index = this.pageList.findIndex((ele: PageDetails) => ele.pageId == page);
                this.entityPages.push(this.pageList[index]);
              }
              for(let entity of response.data.entity_relation) {
                const entityDetails = this.entityList.find((ele: Entity) => ele.entity_id == entity.child_entity_id);
                if(entityDetails) {
                  this.relativeEntity.push(entityDetails);
                  this.relativeEntityForPostData[entity.child_entity_id] = entity;
                }
              }
              this.pageListDropdown = this.pageList?.filter(page => !this.entityPages?.some(entityPage => entityPage?.pageId === page?.pageId));
              this.pageListDropdown?.sort((a, b) => a?.pageName?.localeCompare(b?.pageName));
              this.relatedEntityList = this.entityList?.filter(entity => !this.relativeEntity?.some(entityPage => entityPage?.entity_id === entity?.entity_id));
              this.relatedEntityList.sort((a, b) => a.entity_name.localeCompare(b.entity_name));
            }
          }
          resolve(response.data);
        },
        complete: () => {},
        error: (error: any) => {
          console.log(error, 'Error in Fetch entity API');
          reject(error);
        } 
      });
    });  
    
    return returnData;
  }

  async fetchPages() {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_PAGES']);

    apiConfig.postData = {
      application_id: this.queryParams['id']
    }
    const defaultPages = ['Splash Screen', 'Login', 'Preview'];
    const defaultPageTypes = ['dataListView','PreviewPage'];
    this.pageList = await new Promise((resolve: any, reject) => {
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (response: PageDetails[]) => {          
          const filteredPages = response.filter((value: PageDetails, index: number) => !defaultPages.includes(value.pageName) && !defaultPageTypes.includes(value?.pageType));          
          resolve(filteredPages);
        },
        complete: () => {},
        error: (error: any) => {
          console.log(error, 'Error in Fetch Pages API');
          reject(error);
        }
      })
    })
  }

  updateEntity(entity_id: string | null = null) {
    const pages: string[] = [];
    const pageList = entity_id? this.entityPages: this.pagesAdded;
    for(let page of pageList) {
      pages.push(page.pageId);
    }
    const index = this.entityList.findIndex((ele: Entity) => ele.entity_id == entity_id); 
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['UPDATE_ENTITY']);
    apiConfig.postData = {
      entity_id: entity_id,
      entity_name: entity_id? this.entityList[index]['entity_name'] :this.entityForm.get('name')?.value,
      child_entity_ids_relation: this.relativeEntityForPostData,
      application_id: this.queryParams['id'],
      page_ids_list: pages,
      removal_page_ids_list: entity_id? this.removedPages: [],
      removal_child_entity_ids_relation: entity_id? this.removedRelativeEntity: []
    }
    
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (response: any) => {
        this.toastrService.success(response.message);
      },
      complete: async () => {
        this.resetPageEntities();
        this.entityList = await this.fetchEntity();
        this.entityDetails = await this.fetchEntity(entity_id);
        this.entityList.map((value: Entity, index: number) => { value.open = value.entity_id == entity_id ? true: false;})
        this.relatedEntityList = this.entityList?.filter(entity => !this.relativeEntity?.some(entityPage => entityPage?.entity_id === entity?.entity_id));
        this.relatedEntityList.sort((a, b) => a.entity_name.localeCompare(b.entity_name));
      },
      error: (error: any) => {
        console.log(error, 'Error While Submitting Entity');
        this.toastrService.error(error?.error?.message);
      }
    })
  }

  

  removeRelativeEntityFromEntity(entityId: string, index: number) {
    // const index = this.entityList.findIndex((ele: Entity) => ele.entity_id = entityId);
    this.removedRelativeEntity.push(entityId);
    this.relativeEntity.splice(index, 1);
    this.relatedEntityList = this.entityList?.filter(entity => !this.relativeEntity?.some(entityPage => entityPage?.entity_id === entity?.entity_id));
    this.relatedEntityList.sort((a, b) => a.entity_name.localeCompare(b.entity_name));
  }

  

  async onEntityClicked(entity: Entity, index: number) {
    this.matPanelStatus = false;
    this.relatedPanelStatus = false;
    
    this.relativeEntity = [];
    this.selectedEntityName = entity.entity_name;
    this.entityPages = [];
    if (this.entityList[index].open) this.entityList[index].open = false;
    else this.entityList[index].open = true;
    this.entityList.forEach((item, i) => {
      if (i !== index) {
        item.open = i === index;
      }
    });
    this.entityDetails = await this.fetchEntity(entity.entity_id);
  }

  deleteEntity(entityId: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['DELETE_ENTITY']);

    apiConfig.postData = {
      application_id: this.queryParams['id'],
      entity_id: entityId
    }

    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (response: any) => {
        this.toastrService.success(response.result);
      },
      complete: async () => {
        this.entityPages = [];
        this.entityList = await this.fetchEntity();
      },
      error: (error: any) => {
        console.log(error, 'Error in Deletion of Entity');
        this.toastrService.error('Error in Deletion of Entity');
      }
    })
  }
   
  resetPageEntities(){
    this.entityForm.reset();
    this.pagesAdded = [];
    this.relativeEntityAdded = [];
    this.isAddAttributes = false;
    this.removedRelativeEntity = [];
    this.removedPages = [];
    this.isAddRelations = true;
    this.isAddEntity = false;
    this.showRelativeField = false;
    this.entityPages = [];
  }

}
